import React, { useState, useEffect } from 'react';
import { API_BASE } from '../../App';

const AdminUsers = ({ onAddUser, onUpdateUser, onDeleteUser }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [passwordData, setPasswordData] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [newUser, setNewUser] = useState({
    email: '',
    role: 'user',
    first_name: '',
    last_name: '',
    phone_number: '',
    gender: '',
    hire_date: '',
    password: '', // Şifre alanı ekle
    confirmPassword: '' // Şifre tekrar alanı ekle
  });
  const [message, setMessage] = useState('');

  // ✅ EKLEME: Filtreleme ve sıralama state'leri
  const [searchQuery, setSearchQuery] = useState('');
  const [filterRole, setFilterRole] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterGender, setFilterGender] = useState('');
  const [sortBy, setSortBy] = useState('full_name');
  const [sortOrder, setSortOrder] = useState('asc');

  useEffect(() => {
    fetchUsers();
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  const fetchUsers = async () => {
  setLoading(true);
  try {
    const response = await fetch(`${API_BASE}/admin/users`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    const data = await response.json();

    // 🔍 Gelen veriyi kontrol edelim
    console.log('API’den gelen kullanıcı verisi:', data);

    if (response.ok) {
      const parsed = (data.users || data || []).map(user => ({
        ...user,
        full_name: [user.first_name ?? user.firstName, user.last_name ?? user.lastName]
          .filter(Boolean)
          .join(' ')
      }));

      // 🔍 Oluşturulan isimli kullanıcı listesini görelim
      console.log('İşlenmiş kullanıcı listesi:', parsed);

      setUsers(parsed);
    } else {
      console.error('Kullanıcılar alınamadı:', data.error);
      setUsers([]);
    }
  } catch (error) {
    console.error('Kullanıcılar alınamadı:', error.message);
    setUsers([]);
  }
  setLoading(false);
};


  // ✅ DÜZELTME: Filtrelenmiş ve sıralanmış kullanıcıları döndüren fonksiyon
  const getFilteredAndSortedUsers = () => {
    let filtered = [...safeUsers];

    // Arama filtreleme
    if (searchQuery.trim()) {
      filtered = filtered.filter(user => 
        user.full_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.phone_number?.includes(searchQuery)
      );
    }

    // Rol filtreleme
    if (filterRole) {
      filtered = filtered.filter(user => user.role === filterRole);
    }

    // ✅ DÜZELTME: Durum filtreleme - boolean ve number değerlerini doğru karşılaştır
    if (filterStatus) {
      if (filterStatus === 'active') {
        // Aktif kullanıcılar: is_active = 1 veya true
        filtered = filtered.filter(user => user.is_active === 1 || user.is_active === true);
      } else if (filterStatus === 'inactive') {
        // Pasif kullanıcılar: is_active = 0 veya false veya null
        filtered = filtered.filter(user => user.is_active === 0 || user.is_active === false || !user.is_active);
      }
    }

    // Cinsiyet filtreleme
    if (filterGender) {
      filtered = filtered.filter(user => user.gender === filterGender);
    }

    // Sıralama
    filtered.sort((a, b) => {
      let valueA = '';
      let valueB = '';

      switch (sortBy) {
        case 'full_name':
          valueA = (a.full_name || '').toLowerCase();
          valueB = (b.full_name || '').toLowerCase();
          break;
        case 'email':
          valueA = (a.email || '').toLowerCase();
          valueB = (b.email || '').toLowerCase();
          break;
        case 'role':
          valueA = a.role || '';
          valueB = b.role || '';
          break;
        case 'hire_date':
          valueA = a.hire_date || '';
          valueB = b.hire_date || '';
          break;
        case 'gender':
          valueA = a.gender || '';
          valueB = b.gender || '';
          break;
        default:
          valueA = (a.full_name || '').toLowerCase();
          valueB = (b.full_name || '').toLowerCase();
      }

      if (sortOrder === 'asc') {
        return valueA.localeCompare(valueB, 'tr-TR');
      } else {
        return valueB.localeCompare(valueA, 'tr-TR');
      }
    });

    return filtered;
  };

  // Güvenlik kontrolü
  const safeUsers = users || [];
  const filteredUsers = getFilteredAndSortedUsers();

  const handleAddUserForm = async (e) => {
    e.preventDefault();
    
    // Admin veya İK rolü seçiliyse şifre kontrolü yap
    if (newUser.role === 'admin' || newUser.role === 'ik') {
      if (!newUser.password || !newUser.confirmPassword) {
        setMessage('Admin kullanıcısı için şifre zorunludur!');
        return;
      }
      if (newUser.password !== newUser.confirmPassword) {
        setMessage('Şifreler eşleşmiyor!');
        return;
      }
      if (newUser.password.length < 6) {
        setMessage('Şifre en az 6 karakter olmalıdır!');
        return;
      }
    }
    
    const success = await handleAddUser(newUser);
    if (success) {
      setMessage('Kullanıcı başarıyla eklendi!');
      setNewUser({
        email: '',
        role: 'user',
        first_name: '',
        last_name: '',
        phone_number: '',
        gender: '',
        hire_date: '',
        password: '',
        confirmPassword: ''
      });
      setShowAddForm(false);
      setTimeout(() => setMessage(''), 3000);
    } else {
      setMessage('Kullanıcı eklenirken hata oluştu!');
    }
  };

  const handleAddUser = async (user) => {
    try {
      const response = await fetch(`${API_BASE}/admin/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(user)
      });

      if (response.ok) {
        fetchUsers(); // Local state'i güncelle
        
        // Parent'ı bilgilendir
        if (onAddUser) {
          onAddUser(); // AdminDashboard'daki handleUsersUpdated'i çağır
        }
        
        return true;
      } else {
        const data = await response.json();
        console.error('Hata:', data.error);
        return false;
      }
    } catch (err) {
      console.error('Bağlantı hatası:', err);
      return false;
    }
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    
    console.log('🔍 handleUpdateUser başladı');
    console.log('🔍 passwordData:', passwordData);
    console.log('🔍 editingUser:', editingUser);
    
    // Şifre kontrolü - sadece dolu ise
    if (passwordData.newPassword || passwordData.confirmPassword) {
      console.log('🔍 Şifre alanları dolu, kontrol ediliyor...');
      
      if (passwordData.newPassword !== passwordData.confirmPassword) {
        console.log('❌ Şifreler eşleşmiyor');
        setMessage('Şifreler eşleşmiyor!');
        return;
      }
      if (passwordData.newPassword.length < 6) {
        console.log('❌ Şifre çok kısa');
        setMessage('Şifre en az 6 karakter olmalıdır!');
        return;
      }
      
      console.log('✅ Şifre kontrolleri geçti');
    } else {
      console.log('ℹ️ Şifre alanları boş');
    }
    
    try {
      const updateData = {
        email: editingUser.email,
        first_name: editingUser.first_name,
        last_name: editingUser.last_name,
        phone_number: editingUser.phone_number,
        gender: editingUser.gender,
        hire_date: editingUser.hire_date,
        role: editingUser.role
      };

      console.log('🔍 Base updateData:', updateData);

      // ŞİFRE GÖNDERİMİNİ KONTROL EDELİM
      if (passwordData.newPassword && passwordData.newPassword.trim() !== '') {
        updateData.password = passwordData.newPassword;
        console.log('🔐 Şifre güncelleniyor:', passwordData.newPassword.length + ' karakter');
        console.log('🔐 Şifre değeri (ilk 3 karakter):', passwordData.newPassword.substring(0, 3) + '***');
      } else {
        console.log('ℹ️ Şifre boş, gönderilmeyecek');
      }

      console.log('📤 Gönderilecek veri:', { 
        ...updateData, 
        password: updateData.password ? `[${updateData.password.length} karakter]` : 'YOK' 
      });

      console.log('🌐 API URL:', `${API_BASE}/admin/users/${editingUser.id}`);
      console.log('🔑 Token var mı:', !!localStorage.getItem('token'));

      const response = await fetch(`${API_BASE}/admin/users/${editingUser.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(updateData)
      });

      console.log('📥 Response status:', response.status);
      console.log('📥 Response ok:', response.ok);

      const data = await response.json();
      console.log('📥 Backend yanıtı:', data);

      if (response.ok) {
        const successMessage = data.passwordUpdated 
          ? 'Kullanıcı bilgileri ve şifre başarıyla güncellendi!'
          : 'Kullanıcı bilgileri başarıyla güncellendi!';
        
        console.log('✅ Başarılı:', successMessage);
        setMessage(successMessage);
        setEditingUser(null);
        setPasswordData({ newPassword: '', confirmPassword: '' });
        fetchUsers();
        
        if (onUpdateUser) {
          onUpdateUser();
        }
        
        setTimeout(() => setMessage(''), 3000);
      } else {
        console.error('❌ Backend hatası:', data);
        setMessage(data.error || 'Kullanıcı güncellenirken hatu oluştu!');
      }
    } catch (error) {
      console.error('❌ Network hatası:', error);
      setMessage('Bağlantı hatası!');
    }
  };

  const handleUpdateRole = async (userId, newRole) => {
    try {
      const response = await fetch(`${API_BASE}/admin/users/${userId}/role`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ role: newRole })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Kullanıcı rolü başarıyla güncellendi!');
        setEditingUser(null);
        // Refresh users list
        fetchUsers();
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.error || 'Rol güncellenirken hata oluştu!');
      }
    } catch (error) {
      setMessage('Bağlantı hatası!');
    }
  };

  const handleUpdateStatus = async (userId, newStatus) => {
    const token = localStorage.getItem('token');
    if (!token) {
      setMessage('Oturum süresi doldu. Lütfen yeniden giriş yapın.');
      return logout();
    }

    try {
      const response = await fetch(`${API_BASE}/admin/users/${userId}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ is_active: newStatus })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(`Kullanıcı ${newStatus ? 'aktif' : 'pasif'} edildi!`);
        fetchUsers();
        
        // Parent'ı bilgilendir
        if (onUpdateUser) {
          onUpdateUser();
        }
        
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.error || 'Durum güncellenirken hata oluştu!');
      }
    } catch (error) {
      setMessage('Bağlantı hatası!');
    }
  };

  const handleDeleteUser = async (userId) => {
    const token = localStorage.getItem('token');
    if (!token) {
      setMessage('Oturum süresi doldu. Lütfen yeniden giriş yapın.');
      return logout();
    }

    if (window.confirm('Bu kullanıcıyı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.')) {
      try {
        const response = await fetch(`${API_BASE}/admin/users/${userId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();

        if (response.ok) {
          setMessage('Kullanıcı başarıyla silindi!');
          fetchUsers();
          
          // Parent'ı bilgilendir
          if (onDeleteUser) {
            onDeleteUser();
          }
          
          setTimeout(() => setMessage(''), 3000);
        } else {
          setMessage(data.error || 'Kullanıcı silinirken hata oluştu!');
        }
      } catch (error) {
        setMessage('Bağlantı hatası!');
      }
    }
  };
  
  return (
    <div className="admin-users">
      <div className="users-header">
        <h3>Kullanıcılar ({filteredUsers.length})</h3>
        <button 
          onClick={() => setShowAddForm(!showAddForm)}
          className="btn-primary"
        >
          + Kullanıcı Ekle
        </button>
      </div>

      {/* ✅ EKLEME: Filtreleme ve Sıralama Alanı */}
      <div className="users-filters">
        <div className="filter-row">
          {/* Sol taraf - Filtreler Grid */}
          <div className="filter-group">
            <div className="filter-grid">
              <div className="filter-grid-row">
                <input
                  type="text"
                  className="users-search-input"
                  placeholder="Ad, email veya telefon ile ara..."
                  value={searchQuery}
                  onChange={e => setSearchQuery(e.target.value)}
                />
                
                <select
                  value={filterRole}
                  onChange={e => setFilterRole(e.target.value)}
                  className="users-filter-select"
                >
                  <option value="">Tüm Roller</option>
                  <option value="admin">Admin</option>
                  <option value="ik">İK</option>
                  <option value="user">Kullanıcı</option>
                </select>
              </div>
              
              <div className="filter-grid-row">
                <select
                  value={filterStatus}
                  onChange={e => setFilterStatus(e.target.value)}
                  className="users-filter-select"
                >
                  <option value="">Tüm Durumlar</option>
                  <option value="active">Aktif</option>
                  <option value="inactive">Pasif</option>
                </select>

                <select
                  value={filterGender}
                  onChange={e => setFilterGender(e.target.value)}
                  className="users-filter-select"
                >
                  <option value="">Tüm Cinsiyetler</option>
                  <option value="male">Erkek</option>
                  <option value="female">Kadın</option>
                  <option value="other">Diğer</option>
                </select>
              </div>
            </div>
          </div>
          
          {/* Sağ taraf - Sıralama */}
          <div className="sort-group">
            <label className="sort-label">Sırala:</label>
            <select
              value={sortBy}
              onChange={e => setSortBy(e.target.value)}
              className="users-sort-select"
            >
              <option value="full_name">Ad Soyad</option>
              <option value="email">Email</option>
              <option value="role">Rol</option>
              <option value="hire_date">İşe Giriş</option>
              <option value="gender">Cinsiyet</option>
            </select>
            <button
              onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
              className="users-sort-direction"
              title={`${sortOrder === 'asc' ? 'Artan' : 'Azalan'} sırada - Değiştir`}
            >
              {sortOrder === 'asc' ? '↑' : '↓'}
            </button>
            <span className="users-filter-count">
              {filteredUsers.length} kullanıcı
            </span>
          </div>
        </div>
      </div>

      {/* Add User Modal */}
      {showAddForm && (
        <div className="modal-overlay" onClick={() => setShowAddForm(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h4>Yeni Kullanıcı Ekle</h4>
              <button 
                className="modal-close"
                onClick={() => setShowAddForm(false)}
              >
                ✕
              </button>
            </div>
            
            <form onSubmit={handleAddUserForm}>
              <div className="modal-body">
                <div className="add-user-info">
                  <strong>Yeni kullanıcı bilgilerini doldurun</strong>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label>Email Adresi</label>
                    <input
                      type="email"
                      placeholder="Email adresi"
                      value={newUser.email}
                      onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Ad</label>
                    <input
                      type="text"
                      placeholder="Ad"
                      value={newUser.first_name}
                      onChange={(e) => setNewUser({ ...newUser, first_name: e.target.value })}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Soyad</label>
                    <input
                      type="text"
                      placeholder="Soyad"
                      value={newUser.last_name}
                      onChange={(e) => setNewUser({ ...newUser, last_name: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Telefon</label>
                    <input
                      type="tel"
                      placeholder="Telefon (5xxxxxxx)"
                      value={newUser.phone_number || ''}
                      maxLength={10}
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/\D/g, '');
                        const withoutZero = rawValue.startsWith('0') ? rawValue.slice(1) : rawValue;
                        const limited = withoutZero.slice(0, 10);
                        setNewUser({ ...newUser, phone_number: limited });
                      }}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Cinsiyet</label>
                    <select
                      value={newUser.gender}
                      onChange={(e) => setNewUser({ ...newUser, gender: e.target.value })}
                      required
                    >
                      <option value="">Cinsiyet seçin...</option>
                      <option value="male">Erkek</option>
                      <option value="female">Kadın</option>
                      <option value="other">Belirtmek İstemiyorum</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Rol</label>
                    <select
                      value={newUser.role}
                      onChange={(e) => setNewUser({ 
                        ...newUser, 
                        role: e.target.value,
                        // Rol değiştiğinde şifre alanlarını temizle
                        password: '',
                        confirmPassword: ''
                      })}
                    >
                      <option value="user">Kullanıcı</option>
                      <option value="ik">İK</option>
                      <option value="admin">Yönetici</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>İşe Giriş Tarihi</label>
                  <input
                    type="date"
                    value={newUser.hire_date}
                    onChange={(e) => setNewUser({ ...newUser, hire_date: e.target.value })}
                  />
                </div>

                {/* Admin/İK Şifre Bölümü - Sadece admin veya ik rolü seçiliyse göster */}
                {(newUser.role === 'admin' || newUser.role === 'ik') && (
                  <div className="password-section">
                    <div className="password-section-title">
                      {newUser.role === 'admin' ? 'Admin' : 'İK'} Şifresi (Zorunlu)
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Şifre</label>
                        <input
                          type="password"
                          placeholder="Admin şifresi (en az 6 karakter)"
                          value={newUser.password}
                          onChange={(e) => setNewUser({
                            ...newUser, 
                            password: e.target.value
                          })}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Şifre Tekrar</label>
                        <input
                          type="password"
                          placeholder="Şifreyi tekrar girin"
                          value={newUser.confirmPassword}
                          onChange={(e) => setNewUser({
                            ...newUser, 
                            confirmPassword: e.target.value
                          })}
                          required
                        />
                      </div>
                    </div>

                    {newUser.password && newUser.confirmPassword && 
                     newUser.password !== newUser.confirmPassword && (
                      <div className="password-error">
                        Şifreler eşleşmiyor!
                      </div>
                    )}

                    {newUser.password && newUser.password.length < 6 && newUser.password.length > 0 && (
                      <div className="password-error">
                        Şifre en az 6 karakter olmalıdır!
                      </div>
                    )}

                    {newUser.password && newUser.confirmPassword && 
                     newUser.password === newUser.confirmPassword && 
                     newUser.password.length >= 6 && (
                      <div className="password-success">
                        Şifreler eşleşiyor!
                      </div>
                    )}

                    <div className="password-info">
                      <p>ℹ️ Admin kullanıcıları için güvenlik nedeniyle şifre belirlenmesi zorunludur.</p>
                    </div>
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button type="submit" className="btn-primary">
                  Kullanıcı Ekle
                </button>
                <button
                  type="button"
                  onClick={() => setShowAddForm(false)}
                  className="btn-secondary"
                >
                  İptal
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit User Modal - existing code unchanged */}
      {editingUser && (
        <div className="modal-overlay" onClick={() => {
          setEditingUser(null);
          setPasswordData({ newPassword: '', confirmPassword: '' });
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h4>Kullanıcı Düzenle</h4>
              <button 
                className="modal-close"
                onClick={() => {
                  setEditingUser(null);
                  setPasswordData({ newPassword: '', confirmPassword: '' });
                }}
              >
                ✕
              </button>
            </div>
            
            <form onSubmit={handleUpdateUser}>
              <div className="modal-body">
                <p className="edit-user-info"><strong>Düzenlenen Kullanıcı:</strong> {editingUser.full_name}</p>
                
                <div className="form-row">
                  <div className="form-group">
                    <label>Email Adresi</label>
                    <input
                      type="email"
                      placeholder="Email adresi"
                      value={editingUser.email || ''}
                      onChange={(e) => setEditingUser({ ...editingUser, email: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Ad</label>
                    <input
                      type="text"
                      placeholder="Ad"
                      value={editingUser.first_name || ''}
                      onChange={(e) => setEditingUser({ ...editingUser, first_name: e.target.value })}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Soyad</label>
                    <input
                      type="text"
                      placeholder="Soyad"
                      value={editingUser.last_name || ''}
                      onChange={(e) => setEditingUser({ ...editingUser, last_name: e.target.value })}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Telefon</label>
                    <input
                      type="tel"
                      placeholder="Telefon (5xxxxxxx)"
                      value={editingUser.phone_number || ''}
                      maxLength={10}
                      onChange={(e) => {
                        const rawValue = e.target.value.replace(/\D/g, '');
                        const withoutZero = rawValue.startsWith('0') ? rawValue.slice(1) : rawValue;
                        const limited = withoutZero.slice(0, 10);
                        setEditingUser({ ...editingUser, phone_number: limited });
                      }}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Cinsiyet</label>
                    <select
                      value={editingUser.gender || ''}
                      onChange={(e) => setEditingUser({ ...editingUser, gender: e.target.value })}
                    >
                      <option value="">Cinsiyet seçin...</option>
                      <option value="male">Erkek</option>
                      <option value="female">Kadın</option>
                      <option value="other">Belirtmek İstemiyorum</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Rol</label>
                    <select
                      value={editingUser.role || 'user'}
                      onChange={(e) => setEditingUser({ ...editingUser, role: e.target.value })}
                    >
                      <option value="user">Kullanıcı</option>
                      <option value="ik">İK</option>
                      <option value="admin">Yönetici</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>İşe Giriş Tarihi</label>
                  <input
                    type="date"
                    value={editingUser.hire_date || ''}
                    onChange={(e) => setEditingUser({ ...editingUser, hire_date: e.target.value })}
                  />
                </div>

                {/* Şifre Değiştirme Bölümü */}
                <div className="password-section">
                  <div className="password-section-title">
                    Şifre Değiştir
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Yeni Şifre</label>
                      <input
                        type="password"
                        placeholder="Yeni şifre (boş bırakabilirsiniz)"
                        value={passwordData.newPassword}
                        onChange={(e) => setPasswordData({
                          ...passwordData, 
                          newPassword: e.target.value
                        })}
                      />
                    </div>

                    <div className="form-group">
                      <label>Yeni Şifre Tekrar</label>
                      <input
                        type="password"
                        placeholder="Yeni şifre tekrar"
                        value={passwordData.confirmPassword}
                        onChange={(e) => setPasswordData({
                          ...passwordData, 
                          confirmPassword: e.target.value
                        })}
                      />
                    </div>
                  </div>

                  {passwordData.newPassword && passwordData.confirmPassword && 
                   passwordData.newPassword !== passwordData.confirmPassword && (
                    <div className="password-error">
                      Şifreler eşleşmiyor!
                    </div>
                  )}

                  {passwordData.newPassword && passwordData.newPassword.length < 6 && passwordData.newPassword.length > 0 && (
                    <div className="password-error">
                      Şifre en az 6 karakter olmalıdır!
                    </div>
                  )}

                  {passwordData.newPassword && passwordData.confirmPassword && 
                   passwordData.newPassword === passwordData.confirmPassword && 
                   passwordData.newPassword.length >= 6 && (
                    <div className="password-success">
                      Şifreler eşleşiyor!
                    </div>
                  )}
                </div>
              </div>

              <div className="modal-footer">
                <button type="submit" className="btn-primary">
                  Kullanıcıyı Güncelle
                </button>
                <button 
                  type="button"
                  onClick={() => {
                    setEditingUser(null);
                    setPasswordData({ newPassword: '', confirmPassword: '' });
                  }}
                  className="btn-secondary"
                >
                  İptal
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {message && (
        <div className={`message ${message.includes('başarı') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}

      {/* ✅ DEĞİŞİKLİK: Users Table - filteredUsers kullan */}
      <div className="users-table-container">
        {filteredUsers.length === 0 ? (
          <div className="no-data">
            {searchQuery || filterRole || filterStatus || filterGender 
              ? 'Filtreye uygun kullanıcı bulunamadı.'
              : 'Henüz hiç kullanıcı bulunmuyor.'
            }
          </div>
        ) : (
          <table className="users-table">
            <thead>
              <tr>
                <th>Ad Soyad</th>
                <th>Email</th>
                <th>Telefon</th>
                <th>Cinsiyet</th>
                <th>Rol</th>
                <th>Durum</th>
                <th>İşe Giriş</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user, index) => (
                <tr key={user.id} className={`table-row ${index % 2 === 0 ? 'even' : 'odd'}`}>
                  <td className="user-name">
                    <div className="name-cell">
                      <span className="full-name">{user.full_name || 'Belirtilmemiş'}</span>
                      {user.role === 'admin' && <span className="admin-badge"></span>}
                    </div>
                  </td>
                  <td className="user-email">{user.email}</td>
                  <td className="user-phone">
                    {user.phone_number ? `0${user.phone_number}` : 'Belirtilmemiş'}
                  </td>
                  <td className="user-gender">
                    {user.gender === 'male' ? 'Erkek' : 
                     user.gender === 'female' ? 'Kadın' : 
                     user.gender === 'other' ? 'Diğer' : 'Belirtilmemiş'}
                  </td>
                  <td className="user-role">
                    {user.role === 'admin' ? 'Yönetici' : user.role === 'ik' ? 'İK' : 'Kullanıcı'}
                  </td>
                  <td className="user-status">
                    {user.is_active ? 'Aktif' : 'Pasif'}
                  </td>
                  <td className="user-hire-date">
                    {user.hire_date ? new Date(user.hire_date).toLocaleDateString('tr-TR') : 'Belirtilmemiş'}
                  </td>
                  <td className="user-actions">
                    <div className="action-buttons">
                      <button                    
                        onClick={() => setEditingUser(user)}                       
                        className="btn-edit"                   
                        title="Düzenle"                 
                      >                   
                        ✏️
                      </button>                 
                      <button                    
                        onClick={() => handleUpdateStatus(user.id, !user.is_active)}                   
                        className={`au-btn-status ${user.is_active ? 'deactivate' : 'activate'}`}                   
                        title={user.is_active ? 'Pasif Et' : 'Aktif Et'}                 
                      >                   
                        {user.is_active ? '⏸️' : '▶️'}                
                      </button>                 
                      <button                    
                        onClick={() => handleDeleteUser(user.id)}                   
                        className="btn-delete"                   
                        title="Sil"                 
                      >                   
                        🗑️               
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminUsers;